import { STORAGE_VERIFY_CONNECTION } from '../../components/common/Storage';

export const setInStorage = (key, value) => {
  try {
    const val =
      value && typeof value === 'object' ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, val);
    return true;
  } catch (error) {
    return false;
  }
};

export const getFromStorage = (key) => {
  const value = sessionStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
};

export const removeFromStorage = (key) => {
  sessionStorage.removeItem(key);
};

export const clearAllStorage = () => {
  const value = sessionStorage.getItem(STORAGE_VERIFY_CONNECTION);
  sessionStorage.clear();
  if(value) {
    sessionStorage.setItem(STORAGE_VERIFY_CONNECTION, value);
  }
};
